import { Controller } from "@hotwired/stimulus";
import { setTriggerExpanded } from "../../utils/disclosure.js";
import { smartMatch } from "../../utils/smart_search.js";

/**
 * GO4S Design System — Select (dropdown custom, mono-sélection).
 * Compatible formulaire : écrit la valeur dans un input hidden + émet "change".
 * Spec : docs/design-system/REFERENCE.md §3
 */
export default class extends Controller {
  static targets = ["input", "label", "panel", "search", "option", "trigger"];

  connect() {
    this.onDoc = this.onDoc.bind(this);
    this.onKey = this.onKey.bind(this);
  }

  setExpanded(v) {
    setTriggerExpanded(this, v);
  }

  disconnect() {
    document.removeEventListener("mousedown", this.onDoc);
    document.removeEventListener("keydown", this.onKey);
  }

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close();
  }

  open() {
    this.panelTarget.hidden = false;
    this.element.classList.add("is-open");
    this.setExpanded(true);
    document.addEventListener("mousedown", this.onDoc);
    document.addEventListener("keydown", this.onKey);
    if (this.hasSearchTarget) {
      this.searchTarget.value = "";
      this.filter();
      this.searchTarget.focus();
    }
  }

  close() {
    this.panelTarget.hidden = true;
    this.element.classList.remove("is-open");
    this.setExpanded(false);
    document.removeEventListener("mousedown", this.onDoc);
    document.removeEventListener("keydown", this.onKey);
  }

  onDoc(e) {
    if (!this.element.contains(e.target)) this.close();
  }

  onKey(e) {
    if (e.key === "Escape") this.close();
  }

  choose(e) {
    const btn = e.currentTarget;
    this.inputTarget.value = btn.dataset.value;
    this.labelTarget.textContent = btn.dataset.label;
    this.labelTarget.classList.remove("ds-select__label--placeholder");
    this.optionTargets.forEach((o) => o.setAttribute("aria-selected", String(o === btn)));
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));
    this.close();
  }

  filter() {
    const q = this.searchTarget.value || "";
    this.optionTargets.forEach((o) => {
      o.hidden = !smartMatch(o.dataset.label || "", q);
    });
  }
}
